import Header from 'providers/components/list/ProvidersListHeader';
import Filters from 'providers/components/list/ProvidersListFilters';
import Table from 'providers/components/list/ProvidersListTable';
import Row from 'providers/components/list/ProvidersListRow';

export default { Header, Filters, Table, Row };



// WEBPACK FOOTER //
// src/modules/secured/modules/providers/components/list/index.js